import loadScript from 'Jsx/Utils/loadScript';

const loadGoogleAndFacebookScripts = () => {
  const scripts = [
    import(/* webpackChunkName: "facebook-sdk" */ 'Jsx/Auth/facebookSdk.js'),
  ];

  if (!window.gapi) {
    scripts.push(
      loadScript({ src: 'https://apis.google.com/js/api:client.js' }),
    );
  }

  return Promise.all(scripts);
};

export default loadGoogleAndFacebookScripts;
